// Public Mapbox token of the frontend (a pk. browser token, also used by components/Area/MapBox*.vue).
export const MAPBOX_TOKEN = 'pk.eyJ1IjoibWFnaW9kZXYiLCJhIjoiY2t3YzdjZ2ltMWZlczJ3cDJubXFheHl0bSJ9.B1spSbf4EfBOlDhYVmRZMQ';
